import "babel-polyfill";
import 'raf/polyfill';
import React from 'react';
import ReactDOM from 'react-dom';
import { createTheme, ThemeProvider } from '@mui/material/styles';

import CssBaseline from '@mui/material/CssBaseline';
import { StyledEngineProvider } from '@mui/material/styles';

import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';

const theme = createTheme({
  palette: {
    primary: {
      light: '#def1ea',
      main: '#0a5d66',
      dark: '#3b5847',
      contrastText: '#fff',
    },
    secondary: {
      light: '#ff7961',
      main: '#4fc3f7',
      dark: '#ba000d',
      contrastText: '#000',
    },
  },
});

ReactDOM.render(
  <React.Fragment>
       <StyledEngineProvider injectFirst>
           <ThemeProvider theme={theme}>
              <CssBaseline />
              <App />
           </ThemeProvider>
       </StyledEngineProvider>
    </React.Fragment>,
  document.getElementById('root')
);
serviceWorker.register();



// WEBPACK FOOTER //
// ./src/index.js